// Thư mục: src/services/dmLoaiXeService.js
import api from "@/api";

/**
 * API service cho "Loại Xe" (Gói Checklist)
 */
export const DmLoaiXeApi = {
  // Lấy danh sách Loại xe (phân trang)
  list({ page = 0, size = 10, sort = "id,desc" } = {}) {
    return api
      .get("/api/dm-loai-xe", { params: { page, size, sort } })
      .then((res) => res.data);
  },

  // Lấy chi tiết 1 Loại xe (kèm các checklist)
  get(id) {
    return api.get(`/api/dm-loai-xe/${id}`).then((res) => res.data);
  },

  // Tạo Loại xe (gửi lên DmLoaiXeRequestDto)
  create(payload) {
    return api.post("/api/dm-loai-xe", payload).then((res) => res.data);
  },

  // Cập nhật Loại xe (gửi lên DmLoaiXeRequestDto)
  update(id, payload) {
    return api.put(`/api/dm-loai-xe/${id}`, payload).then((res) => res.data);
  },

  // Xóa Loại xe
  remove(id) {
    return api.delete(`/api/dm-loai-xe/${id}`).then((res) => res.data);
  },

  listActiveOptions() {
    return api.get("/api/dm-loai-xe/active-options").then((res) => res.data);
  },
};
